import { IUser } from "interfaces/models/IUser";
import { GlobalState } from "little-state-machine";

export const updateSelectedUser = (state: GlobalState, selectedUser: IUser) => ({
  ...state,
  selectedUser
});
